export const fields = {
    customer: {
        title: 'Customer',
        placeholder: 'Vendor Name'
    },
    branch: {
        title: 'Customer Branch',
    },
    paymentAmount: {
        title: 'Payment Amount',
    },
    paymentMode: {
        title: 'Payment Mode',
    },
    paymentDate: {
        title: 'Payment Date',
        placeholder: 'Date'
    },
    bank: {
        title: 'Select Bank',
    },
    chequeNo: {
        title: 'Cheque No',
    },
    refNo: {
        title: 'Reference Number',
    },
    transactionDate: {
        title: 'Transaction Date',
        placeholder: 'Date'
    },
    finalAmount: {
        title: 'Final Amount',
    },
    currencySymbol: '₹',
}

export const buttons = {
    submit: 'Submit',
}